
import {share} from 'rxjs/operators';
import { OnInit, DoCheck } from '@angular/core';
import { Helpers } from '../../../helpers';
import { PagingRequest, IPage } from '../../../models/common/paging';
import { Subscription } from 'rxjs';
import { ISearchService } from '../../../services/search.service';
require('rxjs/add/operator/share');

export abstract class SearchComponent<TRequest extends PagingRequest, TResponse> implements OnInit, DoCheck {
    protected subscription: Subscription;
    private previousRequest: TRequest;
    results: IPage<TResponse> = null;

    constructor(public request: TRequest, private searchService: ISearchService<TRequest, TResponse>, protected helpers: Helpers) {
        this.previousRequest = this.helpers.clone(this.request);
    }

    ngOnInit() {
        this.search();
    }

    ngDoCheck() {
        if (!this.request.equals(this.previousRequest)) {
            this.search();
        }
    }

    search() {
        if (this.previousRequest.pageNumber === this.request.pageNumber) {
            //We changed something other than the page number, so reset the search to page 1
            this.request.pageNumber = 0;
        }

        this.previousRequest = this.helpers.clone(this.request);

        if (this.subscription) {
            this.subscription.unsubscribe();
        }

        const observableResponse = this.searchService.search(this.request).pipe(share());

        this.subscription = observableResponse.subscribe(
            results => this.searchCallback(results),
            error => {},
            () => this.completeCallback()
        );

        return observableResponse;
    }

    searchCallback(results: IPage<TResponse>) {
        this.results = results;
    }

    //Overridden in some subclasses
    completeCallback() { }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/search/search.component.ts